<template>
  <el-container>
    <div v-if="isShowPage" style="width: 100%;">
      <div class="header">
        <div class="header-title">{{ albumInfo.name + '电子相册' }}</div>
        <div class="header-menu">
          <el-button type="text" :class="this.switchover==='img'?'checked':'unchecked'" @click="buttonClick('img','图片')">图片<br>
            <p v-if="this.switchover==='img'" style="position: absolute;margin-top: 5px;margin-left: -12px;" class="el-icon-caret-top"></p>
          </el-button>
          <el-button type="text" :class="this.switchover==='video'?'checked':'unchecked'" @click="buttonClick('video','视频')" style="margin-left: 114px; margin-right: 114px;">视频<br>
            <p v-if="this.switchover==='video'" style="position: absolute;margin-top: 5px;margin-left: -12px;" class="el-icon-caret-top"></p>
          </el-button>
          <el-button type="text" v-if="albumInfo.remark != ''" :class="this.switchover==='remark'?'checked':'unchecked'" @click="buttonClick('remark','备注')">备注<br>
            <p v-if="this.switchover==='remark'" style="position: absolute;margin-top: 5px;margin-left: -12px;" class="el-icon-caret-top"></p>
          </el-button>
        </div>
      </div>
      <div class="body">
        <div class="body-title">
          <span class="scroll-to" ref="scroll-to-0">图片</span><br><label>PICTURE</label><br>
          <div style="border: 2px solid #2B60DB; width: 50px; margin: 5px auto;>"></div>
          <div class="clearfix" style="position: relative; top: 0; z-index: 999; width: 50%; margin-left: 50%;">
            <!-- 排序下拉列表放置在最右侧 -->
            <div style="display: flex; justify-content: flex-end;margin-top: -30px">

              <!-- 手机版按钮 -->
              <div class="mobile-button">
                <el-popover placement="bottom-start" trigger="hover" ref="popover">
                  <el-button type="primary" slot="reference"><i class="el-icon-mobile-phone"></i> 手机版</el-button>
                  <slot><img :src="qrCodeUrl" style="width: 150px; height: 150px;"></slot>
                </el-popover>
              </div>
              <div style="margin-left: 10px;">
                <el-button v-if="sortOrder==='asc'" type="text" @click="sortImgList('desc')">排序<p style="margin-top: -10px;" class="el-icon-caret-top"></p></el-button>
                <el-button v-if="sortOrder==='desc'" type="text" @click="sortImgList('asc')">排序<p style="margin-top: -10px;" class="el-icon-caret-bottom"></p></el-button>
              </div>
            </div>
          </div>
        </div>
        <el-row :gutter="20" style="max-height: 440px; overflow-y: auto;">
          <el-col :span="6" v-for="(img, index) in sortedImgList" style="margin-top: 8px; margin-bottom: 8px;">
            <div class="demo-image__preview">
              <el-image style="width: 100%; height: 200px" :src="img.imgUrl400" :initial-index="index" :preview-src-list="srcList" fit="cover" lazy></el-image>
            </div>
          </el-col>
        </el-row>
        <div class="body-title">
          <span class="scroll-to" ref="scroll-to-1">视频</span><br><label>VIDEO</label><br>
          <div style="border: 2px solid #2B60DB; width: 50px; margin: 5px auto;>"></div>
        </div>
        <div style="margin-top: 30px;">
          <img v-if="videoList.length === 0" src="../assets/image/album/bg_video_default.jpg" style="width: 100%;">
          <video-player v-for="(img) in videoList" class="video-player vjs-custom-skin single-video"
                        :options="{ sources: [{ src: img.imgUrl, type: 'video/mp4' }], poster: 'image/poster.jpg', fluid: true, playbackRates: [0.5, 1.0, 1.5, 2.0, 3.0], controls: true, aspectRatio: '16:9'}"></video-player>
        </div>
        <div class="body-title" v-if="albumInfo.remark != ''">
          <span class="scroll-to" ref="scroll-to-2">备注</span><br><label>REMARKS</label><br>
          <div style="border: 2px solid #2B60DB; width: 50px; margin: 5px auto;>"></div>
        </div>
        <p style="margin-top: 20px;">{{ albumInfo.remark }}</p>
      </div>
      <el-backtop></el-backtop>
    </div>
    <error v-else></error><!-- 异常页面 -->
  </el-container>

</template>

<script>
import axios from 'axios'
import qrCode from 'qrcode'
import error from '@/components/error.vue'
import {mapState} from "vuex";

export default {
  components: {error},
  data() {
    return {
      sortOrder: 'asc', // 默认排序方式为正序
      selectedTab: 'image', // 当前选中的标签页
      isCarouselVisible: false, // 是否显示轮播图
      isShowPage: false, // 是否显示页面
      imgList: [], // 图片列表
      videoList: [], // 视频列表
      sortedImgList: [], // 用于存储排序后的图片列表
      jsonData: [], // json数据
      albumInfo: { // 相册信息
        name: '',
        remark: '',
        h5url: '',
      },
      qrCodeUrl: '', // 二维码图片链接
      srcList: [], // 预览图片列表
      switchover: 'img', // 切换按钮状态
      currentActiveIndex: 0, // 当前选中的标题索引
      sections: [
        // 标题数据，每个标题包含 title 和 label
        { title: '图片', label: 'img' },
        { title: '视频', label: 'video' },
        { title: '备注', label: 'remark' },
      ],
    };
  },
  watch:{
    currentActiveIndex(newData, oldData) { // 监听当前选中的标题索引变化
      if (newData === 0) { // 如果当前选中的标题索引为0，则切换按钮状态为img
        this.switchover = 'img'
      } else if (newData === 1) { // 如果当前选中的标题索引为1，则切换按钮状态为video
        this.switchover = 'video'
      } else { // 如果当前选中的标题索引为其他值，则切换按钮状态为remark
        this.switchover = 'remark'
      }
    },
  },
  async mounted() { // 页面加载时执行
    await this.fetchJsonData() // 获取json数据
    window.addEventListener('scroll', this.handleScroll);// 监听滚动事件

  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);// 删除
  },
  computed: {
    ...mapState(['envConfig']) // 从Vuex中获取envConfig数据
  },
  methods: {
    async fetchJsonData() {
      let url = window.location.href // 获取当前页面的URL
      console.log('url = ' + url)
      let key = url.substring(url.indexOf('?') + 1) // 获取URL中的参数
      if (!key) { // 如果没有参数，则显示错误提示框并返回
        this.openAlert()
        return
      }
      if (url.indexOf("=#") !== -1) { // 解决微信转发的问题
        url = url.replace("=#", "#");
      }
      let folder = ''; // 初始化文件夹变量
      if (key.indexOf('#') !== -1) { // 如果URL中包含#，则处理参数
        let params = key.split("#") // 将参数拆分为数组
        key = params[0].substring(0, params[0].length - 10); // 获取数组中的第一个元素，并去掉后缀
        folder = this.insertCharAt(this.insertCharAt(params[1], 4, "/"), 7, "/") + "/" // 处理数组中的第二个元素，并拼接成文件夹路径
      }
      const that = this
      await axios.get(this.envConfig.staticUrl + `/albumv3/${folder}${key}`).then(response => {
        that.jsonData = response.data // 设置json数据
        that.processResponseData(that) // 处理响应数据
      }).catch(error => {
        console.error('Error fetching JSON data:', error)
        this.openAlert()
      });
    },
    insertCharAt(str, index, char) { // 在字符串中插入字符
      return str.slice(0, index) + char + str.slice(index);
    },
    processResponseData(that) { // 数据处理
      console.log(that.jsonData.status)
      if(that.jsonData.status === '0'){ // 如果状态为0，则视为不启用并显示错误提示框
        this.openAlert();
        return;
      }
      document.title = that.jsonData.name; // 设置页面标题
      let albumUrl=this.envConfig.albumUrl; // 获取电子相册URL
      if (that.jsonData.imgList != null && that.jsonData.imgList != undefined) { // 如果图片列表不为空，则进行处理
        that.imgList = JSON.parse(that.jsonData.imgList); // 将图片列表转换为JSON对象
        that.imgList.forEach(item => { // 对每个图片进行处理
          if(albumUrl.includes("/profile")){ // 兼容开发环境
            item.imgUrl400 = (this.envConfig.albumUrl + item.imgUrl400).replace("/resources/finreport", "");
            item.imgUrl = (this.envConfig.albumUrl + item.imgUrl).replace("/resources/finreport", "");
          }else{ // 正式环境
            item.imgUrl400 = this.envConfig.albumUrl + item.imgUrl400;
            item.imgUrl = this.envConfig.albumUrl + item.imgUrl;
          }
        });
      }
      if (that.jsonData.videoList != null && that.jsonData.videoList != undefined) { // 如果视频列表不为空，则进行处理
        that.videoList = JSON.parse(that.jsonData.videoList); // 将视频列表转换为JSON对象
        that.videoList.forEach(item => { // 对每个视频进行处理
          if(this.envConfig.albumUrl.includes("/profile")){ // 兼容开发环境
            item.imgUrl = this.envConfig.albumUrl + item.imgUrl.replace("/resources/finreport", "");
          }else{ // 正式环境
            item.imgUrl = this.envConfig.albumUrl + item.imgUrl;
          }
        });
      }
      that.albumInfo.remark = that.jsonData.remark; // 设置备注信息
      that.albumInfo.name = that.jsonData.name; // 设置相册名称
      that.albumInfo.h5url = that.jsonData.h5url; // 设置h5地址
      that.srcList = that.imgList.map(item => item.imgUrl); // 设置预览图片列表
      this.sortImgList('asc'); // 初始加载数据后进行排序
      this.generateQRCode(); // 生成二维码
      this.isShowPage = true; // 显示页面
    },
    openAlert() { // 显示错误提示框
      this.$alert('路径或者名称有误，请检查后重新输入', '', {
        confirmButtonText: '确定',
        callback: action => {
          if (action === 'confirm') {
            this.isShowPage = false;
          }
        },
      })
    },
    sortImgList(value) { // 排序图片列表
      this.sortOrder = value; // 设置排序顺序
      if (this.sortOrder === 'asc') {
        // 正序排序
        this.sortedImgList = [...this.imgList]; // 使用展开运算符创建副本
        this.srcList= this.sortedImgList.map(item => item.imgUrl); // 更新 srcList
      } else if (this.sortOrder === 'desc') {
        // 倒序排序
        this.sortedImgList = [...this.imgList].reverse(); // 使用展开运算符创建副本并反转
        this.srcList= this.sortedImgList.map(item => item.imgUrl); // 更新 srcList
      }
    },
    generateQRCode() { // 生成二维码
      qrCode.toDataURL(this.albumInfo.h5url, {width: 150}, (err, url) => { // 使用qrcodejs库生成二维码
        if (!err) { // 生成成功将生成的二维码URL赋值给qrCodeUrl
          this.qrCodeUrl = url;
        } else {
          console.error('Error generating QR code:', err);
        }
      });
    },
    buttonClick(value, item) { // 切换按钮点击事件
      this.switchover = value; // 设置切换按钮的值
      const labels = document.querySelectorAll('.scroll-to'); // 获取所有带有scroll-to类的标签
      labels.forEach(label => {
        if (label.textContent.trim() === item) { // 如果标签的文本内容与传入的item匹配
          label.scrollIntoView({ // 滚动到该标签
            behavior: 'smooth'
          });
        }
      });
    },
    handleScroll() { // 滚动事件处理
      const titles = this.$refs; // 获取所有带有ref属性的dom元素
      let current = 0; // 初始化当前激活的标题索引为0
      let scrollY = window.scrollY || document.documentElement.scrollTop;// 兼容不同浏览器
      for (let i = 0; i < this.sections.length; i++) {
        let titleEl = titles[`scroll-to-${i}`]; // 获取带有ref属性的dom元素
        if (titleEl && scrollY >= titleEl.offsetTop - 100) {// 如果找到了对应的 DOM 元素，并且滚动条的位置大于或等于该元素顶部的位置减去100作为边界
          current = i;// 更新当前应该激活的标题索引
        }
      }

      if (current !== this.currentActiveIndex) {// 如果新计算的当前激活索引与现有索引不同，则更新现有索引
        this.currentActiveIndex = current;
      }
    },
  }
};

</script>

<style scoped lang="scss">
.header {
  width: 100%;
  height: 286px;
  background-image: url(../assets/image/album/bg_web_top.jpg);
  background-repeat: no-repeat;
  background-size: 100% 100%;
}

.header-title {
  width: 100%;
  height: 201px;
  line-height: 200px;
  text-align: center;
  font-size: 40px;
  font-weight: bold;
  color: #ffffff;
}

.header-menu {
  width: 100%;
  height: 85px;
  background: #ffffff;
  opacity: 0.62;
  text-align: center;
  line-height: 85px;
}

.checked {
  font-weight: bold;
  font-size: 24px;
  color: #2B60DB;
}

.unchecked {
  font-size: 24px;
  color: #1f1f1f;
}

.body {
  max-width: 1200px;
  width: 100%;
  margin: 0 auto;
  text-align: center;
}

.body-title {
  margin-top: 25px;
  font-size: 20px;
  color: #1F1F1F;

  label {
    color: #A4A4A4;
    font-size: 16px;
    letter-spacing: 4.4px
  }
}

.mobile-button {
  display: inline-block;
  cursor: pointer;
  margin-right: 10px;
}

.el-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.custom-tab {
  font-size: 20px;
  font-weight: 700;
}

.single-video {
  width: 100%; /* 视频宽度占据父元素宽度 */
  height: 100%;
  object-fit: cover;
  margin-top: 5px;
}
</style>